import jsonLogic from 'json-logic-js';
import jsonLogicExtensions from 'json-logic-extensions';

// Add the extensions library to JSON logic.
jsonLogicExtensions.extend(jsonLogic);

export function evaluate(expression, variables) {
  try {
    return jsonLogic.apply(expression, variables);
  }
  catch(e) {
    return false;
  }
}

export function getVariables(answers, questions) {
  let questionsById = questions;

  if (Array.isArray(questions)) {
    questionsById = questions.reduce((map, question) => {
      map[question.id] = question;
      return map;
    }, {});
  }

  return answers.reduce((map, answer) => {
    const type = questionsById[answer.questionId].type;

    if(map[answer.questionId]) {
      map[answer.questionId] = [...map[answer.questionId], parseAnswerValue(answer.value, type)];
    }
    else {
      map[answer.questionId] = parseAnswerValue(answer.value, type);
    }

    return map;
  }, {});
}

export function parseAnswerValue(value, questionType) {
  switch (questionType) {
    case 'NUMERIC':
    case 'MEASURED_NUMERIC':
    case 'INVENTORY_RECEIVING':
    case 'INVENTORY_USAGE': // the answer value of an inventory question is the amount
      return Number(value);
    case 'BOOLEAN':
      return value.toString() === "true";
    default:
      return value;
  }
}

export function swapIds(expression, ids) {
  if(expression === null || typeof expression !== 'object'){
    return expression;
  }

  if('var' in expression){
    return {
      var: ids[expression.var] || expression.var
    };
  }

  const operator = Object.keys(expression)[0];
  const operands = expression[operator];

  return {
    [operator]: Array.isArray(operands) ? operands.map(op => swapIds(op, ids)) : swapIds(operands, ids)
  };
}

export function parseVariables(expression) {
  if (expression === null || expression === undefined || typeof expression !== 'object') {
    return [];
  }

  if (expression.var) {
    return [expression.var];
  }

  const operator = Object.keys(expression)[0];
  return expression[operator].reduce((vars, operand) => [...vars, ...parseVariables(operand)], []);
}

// Whether a variable reference still resolves against the list a builder is offering. A formula can outlive
// the variable it points at, e.g. when a question moves to sheet setup and the row questions drop out.
export function isKnownVariable(variables, name) {
  return !!variables && Object.prototype.hasOwnProperty.call(variables, name);
}
